/* global $ */

function init() {

	$('.accordion').each((index, el) => {

		const $item = $(el);
		const $header = $item.find('.accordion__header');
		const $content = $item.find('.accordion__content');

		$header.on('click', () => {
			$item.toggleClass('hidden');
			$content.stop().slideToggle();
		});

	});

}

export default {
	init
};
